module.exports = __webpack_public_path__ + "img/clue04.3d9b4b8f.png";